import { forwardRef, ReactNode, Ref } from "react";
import classNames from "classnames";

import { BlockType, LineType, SongBlockType } from "../types";

type WrapperProps = {
  children: ReactNode,
  className?: string,
  editable?: boolean
};

type BlockWrapperProps = WrapperProps & {
  blockType: BlockType,
  descriptor: string
}

const INDENTED_BLOCKS: BlockType[] = [
  SongBlockType.CHORUS
];

const ITALIC_BLOCKS: BlockType[] = [
  SongBlockType.CHORUS,
  SongBlockType.BRIDGE
];

export const BlockWrapper = ({ blockType, children, className, descriptor }: BlockWrapperProps) => {

  const classes = classNames(
    'bg-white rounded-sm mx-4 mt-1',
    {
      'ml-8': INDENTED_BLOCKS.includes(blockType),
      'italic': ITALIC_BLOCKS.includes(blockType),
    }
  );

  const wrapperClasses = classNames(
    'px-2 pb-2 mb-1 border-l-2 text-lg',
    className
  );

  return (
    <div className={wrapperClasses}>
      <span
        className='text-neutral-400 text-base select-none'
        contentEditable={false}
      >
        {descriptor}
      </span>
      <div className={classes}>
        { children }
      </div>
    </div>
  );
};

type LineGroupWrapperProps = WrapperProps;

export const LineGroupWrapper = forwardRef(({ children, className, editable }: LineGroupWrapperProps, ref: Ref<HTMLDivElement>) => {

  const classes = classNames(
    'px-2 rounded-sm',
    className,
    {
      'border border-dashed border-b-0 last:border-b': editable,
      'hover:bg-blue-100': !editable
    }
  );

  return (
    <div
      className={classes}
      ref={ref}
    >
      { children }
    </div>
  );

});


type LineWrapperProps = WrapperProps & {
  lineType: LineType,
  onClick?: () => void
}

export const LineWrapper = ({ children, className, editable, lineType, onClick }: LineWrapperProps) => {
  const classes = classNames(
    {
    'cursor-default': !editable,
    'text-neutral-500': lineType === LineType.MINOR.valueOf()
    },
    className
  );

  return (
    <p
      className={classes}
      onClick={onClick}
    >
      {children}
    </p>
  );

};
